/**
 * Type guard que verifica se o container é o `window` global.
 * Usar no lugar de `instanceof Window` porque em ambientes de teste (JSDOM)
 * `window instanceof Window` retorna `false`, quebrando o narrowing de tipo.
 */
export function isWindow(container: HTMLElement | Window): container is Window {
  return container === window
}
